/**
 * Zauberkarten-Konstanten (Single Source of Truth)
 *
 * Diese Datei definiert alle Konstanten für das Zauberkarten-System.
 *
 * Verwendung:
 * - Server: const { MAGIC_CARD_EVENTS } = require('../../src/shared/core/magicCardConstants');
 * - Client: import { MAGIC_CARD_EVENTS } from './shared/core/magicCardConstants';
 */

// =============================================================================
// MAGIC CARD STATUS
// =============================================================================

/**
 * Status einer Zauberkarte
 */
const MAGIC_CARD_STATUS = {
  DRAWN: 'drawn',           // Zauberkarte wurde gezogen
  ANIMATING: 'animating',   // Animation läuft (Karte fliegt)
  MINIGAME: 'minigame',     // Minispiel wird gestartet
  COMPLETED: 'completed',   // Zauberkarte abgeschlossen
};

// =============================================================================
// SOCKET EVENTS
// =============================================================================

/**
 * Socket-Events für Zauberkarten-Kommunikation
 */
const MAGIC_CARD_EVENTS = {
  // Server → Client
  DRAWN: 'magicCardDrawn',           // Zauberkarte wurde gezogen
  ANIMATION_START: 'magicCardAnimationStart', // Animation startet
  ANIMATION_END: 'magicCardAnimationEnd',     // Animation beendet

  // Client → Server (falls nötig)
  ANIMATION_COMPLETE: 'magicCardAnimationComplete', // Client meldet Animation fertig
};

// =============================================================================
// TIMING CONSTANTS
// =============================================================================

/**
 * Timing-Konstanten für Zauberkarten-Animationen
 * Diese werden auch in animationTimings.js referenziert
 */
const MAGIC_CARD_TIMINGS = {
  flyDuration: 1000,        // Karte fliegt vom Deck zur Mitte (1s)
  eventLogDelay: 2000,      // Event Log erscheint 2s nach Start (1s nach Landung)
  displayDuration: 5000,    // Karte wird angezeigt (5s) - dann startet Minispiel
  totalDuration: 6000,      // Gesamtdauer bis Minispiel startet (1s länger)
};

// =============================================================================
// EXPORTS
// =============================================================================

module.exports = {
  MAGIC_CARD_STATUS,
  MAGIC_CARD_EVENTS,
  MAGIC_CARD_TIMINGS,
};
